import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Flexbox from "../components/Flexbox";
import { Container, Typography } from "@mui/material";
import Spacebox from "../components/Spacebox";
import Grid from "../components/Grid";
import Button from "../components/Button";
import Company from "../utilities/Company";
import { isMobile } from "react-device-detect";
import Footer from "../components/Footer";

const Contact = ({ title }) => {

    document.querySelector('title').innerHTMl = title

    const navigate = useNavigate()

    const infos = [
        {
            image: '/svgs/calender.svg',
            heading: 'Schedule a Call',
            content: 'Book a consultation with our funding specialists',
            cta: 'Schedule now',
            action: () => navigate('/book')
        },
        {
            image: '/svgs/email.svg',
            heading: 'Email Us',
            content: `Get answers to your funding questions.`,
            cta: 'Send Email',
            action: () => window.location.href = `mailto:${Company.email}`
        }

    ]


    return (
        <div className="contact-page">
            <Header />
            <section>
                <Flexbox justifyContent="center" alignItems="center">
                    <Container>
                        <Spacebox padding="20px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '40px' : '60px', color: 'var(--primary)' }}>
                            Get in Touch
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ textAlign: 'center', color: '#00000060', fontSize: isMobile ? '18px' : '20px' }}>
                            We're on a mission to revolutionize business funding by making it more <br />
                            accessible, transparent, and tailored to your unique needs.
                        </Typography>
                        <Spacebox padding="10px" />
                        <Grid grid={isMobile ? 1 : 2} gap="20px">
                            {infos.map((a, i) => (
                                <div key={i} style={{ padding: '20px', borderRadius: '10px', border: '1px solid #4A3FFF20' }}>
                                    <Flexbox alignItems="center" justifyContent="center" style={{ display: 'inline-block', padding: '10px', backgroundColor: '#4A3FFF20', borderRadius: '5px' }}>
                                        <img src={a.image} alt={a.heading} style={{ width: '30px' }} />
                                    </Flexbox>
                                    <Spacebox padding="10px" />
                                    <Typography>
                                        <b>
                                            {a.heading}
                                        </b>
                                    </Typography>
                                    <Spacebox padding="10px" />
                                    <span className="content" style={{ opacity: .6 }}>
                                        {a.content}
                                    </span>
                                    <Spacebox padding="10px" />
                                    <Button className="hide-on-mid-and-small" style={{ borderRadius: '5px', padding: '15px 40px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={a.action}>
                                        <Flexbox alignItems="center">
                                            <b style={{ fontSize: '18px' }}>{a.cta}</b>
                                            <Spacebox padding="10px" />
                                            <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                        </Flexbox>
                                    </Button>
                                    <Button className="hide-on-large-only" style={{ borderRadius: '5px', padding: '10px 0px', backgroundColor: 'var(--primary)', color: 'white', width: '100%' }} handleClick={a.action}>
                                        <b style={{ fontSize: '18px' }}>{a.cta}</b>
                                    </Button>
                                </div>
                            ))}
                        </Grid>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                        <Typography variant="h3" style={{ textAlign: 'center', fontSize: isMobile ? '25px' : '30px', }}>
                            Ready to Transform Your Business?
                        </Typography>
                        <Spacebox padding="10px" />
                        <Typography style={{ opacity: .6, textAlign: 'center', fontSize: '18px' }}>
                            Our funding specialists are ready to help you explore the best options for <br />your business growth.
                        </Typography>
                        <Spacebox padding="10px" />
                        <Flexbox alignItems="center" justifyContent="center">
                            <Button className="hide-on-mid-and-small" style={{ borderRadius: '5px', padding: '15px 40px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/book')}>
                                <Flexbox alignItems="center">
                                    <b style={{ fontSize: '18px' }}>Book A Consultation</b>
                                    <Spacebox padding="10px" />
                                    <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                </Flexbox>
                            </Button>
                            <Button className="hide-on-large-only" style={{ borderRadius: '5px', padding: '10px 20px', backgroundColor: 'var(--primary)', color: 'white' }} handleClick={() => navigate('/book')}>
                                <Flexbox alignItems="center">
                                    <b style={{ fontSize: '18px' }}>Book A Consultation</b>
                                    <Spacebox padding="10px" />
                                    <img src="/svgs/arrow-right.svg" alt="arrow-right" style={{ width: '18px', filter: 'invert(1)' }} />
                                </Flexbox>
                            </Button>
                        </Flexbox>
                        <Spacebox padding="20px" />
                        <Spacebox padding="20px" />
                    </Container>
                </Flexbox>
            </section>
            <Footer />
        </div>
    );
}

export default Contact;